import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal, openHelp, setModalDelay } from '../../state/actions/modal';
import { HideModal, INeedHelp } from '../stateless/buttons';
import Players from '../players';

/**
 * @class Modal
 *
 * @description
 * Class for a showing a modal questions on screen.
 *
 * @example
 * <Modal />
 */
@connect(
	state => ({
		isModalDelayed: state.modal.isModalDelayed,
		isModalClosed: state.modal.isModalClosed,
		hasPlayers: state.appView === 'game',
		translations: state.setup.translations,
		countryCode: state.user && state.user.profileData ? state.user.profileData.countryCode : 'EN'
	}),
	dispatch => ({
		setModalDelay: (bool) => {
			dispatch(setModalDelay(bool));
		},
		closeModal: () => {
			dispatch(closeModal());
		},
		openHelp: () => {
			dispatch(openHelp());
		}
	})
)
export default class Modal extends Component {

	static propTypes = {
		transitionKey: PropTypes.string,
		isModalDelayed: PropTypes.bool,
		forceOpen: PropTypes.bool
	};

	componentWillReceiveProps (newProps) {
		if (newProps.isModalDelayed) {
			setTimeout(() => {
				this.props.setModalDelay(false);
			}, 1900)
		}
	}

	getModalClasses () {
		let classes = 'modal__table';

		if (this.props.isModalDelayed) {
			classes += ' modal-delayed';
		}

		if (this.props.isModalClosed && !this.props.forceOpen) {
			classes += ' modal-leave-active';
		}

		return classes;
	}

	render () {
		const { hasPlayers, translations, countryCode } = this.props;

		return (
			<CSSTransitionGroup
				className="modal"
				transitionName="modal"
				transitionAppear={true}
				transitionAppearTimeout={600}
				transitionEnterTimeout={600}
				transitionLeaveTimeout={400}>
				<div className={this.getModalClasses()}
						 key={this.props.transitionKey}>
					<div className="modal-inner" />
					{hasPlayers && <Players />}
					<div className="modal__cell">
						<div className="modal__content-outer">
							<div className="modal__content content-box--4x">
								{this.props.help &&
								<INeedHelp openHelp={() => this.props.openHelp}
													 text={translations.iNeedHelp[countryCode]} />
								}
								{!this.props.forceOpen &&
								<HideModal hideModal={() => this.props.closeModal}
													 text={translations.hide[countryCode]} />
								}
								{this.props.children}
							</div>
						</div>
					</div>
				</div>
			</CSSTransitionGroup>
		);
	}
}
